import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { PreguntaComponent } from './pregunta/pregunta.component';
import Swal from 'sweetalert2';
import { fuseAnimations } from '@fuse/animations';

import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import * as backInter from 'app/auth/auth-data.model';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'preguntasAdicionales',
  templateUrl: './preguntas.component.html',
  styleUrls: ['./preguntas.component.scss'],
  animations   : fuseAnimations
})
export class PreguntasComponent implements OnInit {
  banderaEncuestaFocus: backInter.actualizaBanderaFocus;
  @Input('productoCertificar') productoCertificar: backInter.prodCert;
  @Input('idiomas') idiomas: backInter.getIdiomas;
  // @Input('preguntasAdicionales') preguntasAdicionales: backInter.getAdicionales;
  @Input('preguntasAdicionales') preguntasAdicionalesFocus: backInter.getPreguntasAdiocnalesFocus;

  @Input('cargando') cargando: boolean;
  @Input('pasoCompleto') pasoCompleto: boolean;
  @Input('bloqueaSeccionAdicional') bloqueaSeccionAdicional: boolean;

  @Output() actualizarAdicionales: EventEmitter<boolean> = new EventEmitter();
  @Output() sinAdicionalesFocus: EventEmitter<boolean> = new EventEmitter();
  @Output() statusSinAdicionales: EventEmitter<boolean> = new EventEmitter();

  ////VARIABLES
  preguntas: any[] = []
  iterador = 0;

  //boolean adicionales
  sinAdic = false;
  //id idioma "sin adicionales"
  idSinAdic: string;
  // bloqueaSeccionAdicional=false;

  // pasoCompleto = false;
 bloqueaSeccionAdicionales:boolean;
  constructor(
    private adicionalesService: AdicionalesService,
    private translateSrv: TranslateService,
    private _snackBar: MatSnackBar,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    console.log('entro esta variable',this.bloqueaSeccionAdicional);
    let esperaDatos = setInterval( () => {
      if(this.preguntasAdicionalesFocus){
        this.colocaOpcionSinAdicionales();
        if(!this.idSinAdic)
          this.colocaPreguntasExistentes();
        clearInterval(esperaDatos);
      }
    }, 0);
    this.getActualizaBanderaEvaluarEncuesta();
  }


  colocaOpcionSinAdicionales(){
  console.log(this.preguntasAdicionalesFocus);
    if(this.preguntasAdicionalesFocus.preguntas.length == 1){
      if(this.preguntasAdicionalesFocus.preguntas[0].orden == -1){
        this.idSinAdic = this.preguntasAdicionalesFocus.preguntas[0]._id;
        console.log("se encuentra seleccionado ", this.idSinAdic);
        //actualiza arreglo de adicionales
        this.sinAdicionalesFocus.emit(true);

        this.sinAdic = true;
      }
    }
  }

  colocaPreguntasExistentes(){
  console.log(this.preguntasAdicionalesFocus);

      if(this.preguntasAdicionalesFocus.preguntas.length > 0){
        this.preguntasAdicionalesFocus.preguntas.forEach( (elemento) => {
          this.agregaPregunta(elemento);
        });
      };
  }

  agregaPregunta(datosPregunta?:backInter.preguntasAdicionalesFocus){
    this.preguntas.push({iterador:this.iterador, datosPregunta:datosPregunta});
    this.iterador++;
  }

  borrarPregunta(id: number){
    let index = 0;
    var BreakException = {};
    try {
        this.preguntas.forEach(function(elemento) {
          if(elemento.iterador === id) throw BreakException;
          index++;
        });
    } catch (e) {
        if (e !== BreakException) throw e;
    }
    this.preguntas.splice(index,1);
    // this.openSnackBar("Se eliminó la pregunta","OK");
  }

  sinAdicionales(e){
    console.log(this.pasoCompleto);

    if(!this.pasoCompleto){
      this.sinAdic = !this.sinAdic;
      console.log("entro este visne ",this.sinAdic);

      if(this.sinAdic){
        if(this.idSinAdic == null){
          console.log("entro es confirmButtonColor");

          this.guardaPreguntaSinAdicionales();
        }
      }
      else{
        this.eliminaPreguntaSinAdicionales();
      }
    }
    else{
      console.log("entro este visne ");
      e.preventDefault();
      this.translateSrv.get('MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.RESTRICCION').subscribe((res: string) => {
        this.mensajeSwal({mensaje: res ,tipo: 'warning'});
      });
    }
  }

  guardaPreguntaSinAdicionales(){
    let adicional = {} as backInter.nuevoAdicional;
    adicional.empresaId = localStorage.getItem('companyID');
    adicional.tipoRespuesta = 3;
    adicional.pregunta = "sin adicionales";
    adicional.seccion= 7;
    adicional.orden = -1;

    // console.log(adicional);
    this.adicionalesService.guardaAdicionalesFocus(adicional).subscribe( (data: any) => {
      console.log(data);
      if(data.message == "200"){
        this.idSinAdic = data.preguntaMostrar._id;
        this.translateSrv.get('CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.NOADICIONALES').subscribe((res: string) => {
          this.openSnackBar(res,'OK');
        });
        this.statusSinAdicionales.emit(true);
      }
      else{
        this.translateSrv.get('CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.ERROR').subscribe((res: string) => {
          this.openSnackBar(res,'OK');
        });
      }
    });
  }

  eliminaPreguntaSinAdicionales(){
    let adicional = {} as backInter.modificarAdicionalFocus;
    adicional.preguntaId = this.idSinAdic;
    adicional.empresaId = localStorage.getItem('companyID');

    this.adicionalesService.borrarPreguntaAdicionalFocus(adicional).subscribe( (data:backInter.respuestaModifAdicional) => {
      if(data.message == "200"){
        this.idSinAdic = null;
        console.log("null ", this.idSinAdic );
    this.sinAdicionalesFocus.emit(false);
        this.translateSrv.get('CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.CANCELNOADIC').subscribe((res: string) => {
          this.openSnackBar(res,'OK');
        });
        this.statusSinAdicionales.emit(false);
      }
      else{
        this.translateSrv.get('CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.ERROR').subscribe((res: string) => {
          this.openSnackBar(res,'OK');
        });
      }
    });

  }

  mensajeSnack(datos:any){
    this.openSnackBar(datos.mensaje,datos.accion);

    //actualiza arreglo de adicionales
    this.actualizarAdicionales.emit(true);
  }
  mensajeSwal(datos:any){
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    Swal.fire({
      title: datos.mensaje,
      icon: datos.tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });

    //actualiza arreglo de adicionales
    this.actualizarAdicionales.emit(true);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.preguntas, event.previousIndex, event.currentIndex);
  }

  getActualizaBanderaEvaluarEncuesta(){
    let datos={productoId:localStorage.getItem('productoID')};
    this.adicionalesService.getActulizaBanderaEncuestaFocus(datos).subscribe( (data: backInter.actualizaBanderaFocus) => {
      console.log(data);


      this.banderaEncuestaFocus=data;
      if (this.banderaEncuestaFocus.estatusVerificacion==2 || this.banderaEncuestaFocus.estatusVerificacion==3 ) {
        this.bloqueaSeccionAdicionales=true;
        console.log(this.bloqueaSeccionAdicional);

      }else{
        this.bloqueaSeccionAdicionales=false;
        console.log(this.bloqueaSeccionAdicional);
      }


      });
  }

}
